export { default } from './CatalogCard';
